import React, { useEffect } from "react";
import { FormattedMessage } from "react-intl";
import { useDispatch } from "react-redux";
import { change } from "redux-form";
import { MERCHANT_IS_MMS } from "./MerchantForm";
import type { Merchant } from "src/merchants/objects/Merchant";
import { CheckboxInput } from "src/shared/forms/inputs/CheckboxInputOld";

interface MerchantFormEnableMmsProps {
  form: string;
  provisioningType: string;
  merchant: Merchant | undefined;
}

export const MerchantFormEnableMms = ({
  form,
  provisioningType,
  merchant,
}: MerchantFormEnableMmsProps) => {
  const dispatch = useDispatch();
  const isShortCode =
    provisioningType === "short" || merchant?.mvnType === "CSC";

  useEffect(() => {
    if (!isShortCode) {
      dispatch(change(form, MERCHANT_IS_MMS, false));
    }
  }, [dispatch, form, isShortCode]);

  return (
    <CheckboxInput
      inputID={MERCHANT_IS_MMS}
      label={<FormattedMessage id="merchants.form.numberProvisioning.isMms" />}
      disabled={!isShortCode}
    />
  );
};
